module.exports = __webpack_public_path__ + "img/no_image.2f45a7de.jpg";